import { Route } from "react-router"
import { DonorLayout } from "./layout"
import { DonorOverviewPage } from "./overview"
import { DonorChildrenPage } from "./children"
import { DonorChildDetailPage } from "./child-detail"
import { DonorGivingPage } from "./giving"
import { DonorSettingsPage } from "./settings"
import { DonorRequestPage } from "./request"

export default (
  <Route path="donor" element={<DonorLayout />}>
    <Route index element={<DonorOverviewPage />} />
    <Route path="children" element={<DonorChildrenPage />} />
    <Route path="children/:id" element={<DonorChildDetailPage />} />
    <Route path="giving" element={<DonorGivingPage />} />
    <Route path="settings" element={<DonorSettingsPage />} />
    <Route path="request" element={<DonorRequestPage />} />
  </Route>
)
